
import { SistemaMixin } from "@/modules/Application";
import TableApp from "@/components/Table/Table2";
import TrashCanIcon from "vue-material-design-icons/TrashCan.vue";
import Pencil from "vue-material-design-icons/Pencil.vue";
import swal from "sweetalert";
import { actionsStore } from "@/components/Table/actionsStore";

export default {
  name: "servicos2",
  mixins: [SistemaMixin],
  components: {
    TableApp,
    TrashCanIcon,
    Pencil,
  },
  data() {
    return {
      actionsStore,
      fields: [
        {
          label: "Descrição",
          field: "descricao",
          type: "text",
          slot: true,
          sortable: false,
        },
        {
          label: "",
          field: "actions",
          sortable: false,
          width: "5%",
          slot: true,
        },
      ],
    }
  },
  created() {
  },
  methods: {
    async handleDeleteTributacao(tributacao) {
      this.$swal
        .fire({
          icon: "warning",
          title: "Excluir a tributacao " + tributacao.descricao + "?",
          showCancelButton: true,
          confirmButtonText: `Sim`,
          cancelButtonText: `Não`,
          confirmButtonColor: "#f64e60",
        })
        .then(async (result) => {
          if (result.isConfirmed) {
            try {
              this.$http.post('/tributacaoservico/delete', {
                id_tributacao_servico: tributacao.id_tributacao_servico,
              })
              this.$toast.success('Tributação excluída com sucesso!')
              this.actionsStore.updateTable = !this.actionsStore.updateTable;
            } catch (error) {
              console.log(error);
            }
          }
        });
    },
    async handleEditTributacao(data) {
      swal({
        title: "Deseja editar a tributação?",
        text: "Você ira ser direcionado para a pagina de edição aguarde...",
        icon: "info",
        buttons: {
          cancel: {
            text: "Cancelar",
            value: "cancel",
            visible: true,
            closeModal: true,
          },
          confirm: {
            text: "OK",
            visible: true,
            closeModal: false,
          },
        },
        dangerMode: false,
        closeModal: false,
        closeOnClickOutside: false,
      }).then(async (value) => {
        if (value === "cancel") {
          swal.close();
          swal.stopLoading();
          return;
        }

        await this.$http
          .post("/tributacaoservico/find", {
            id_tributacao_servico: data.id_tributacao_servico,
          })
          .then((response) => {
            swal.stopLoading();
            swal.close();
            this.$toast.info("Você será redirecionado agora");
            this.$router.push({
              name: "nova-tributacaoServicos",
              params: { tributacaoData: { ...response.data, id_tributacao_servico: data.id_tributacao_servico } },
            });
          })
          .catch(() => {
            swal.stopLoading();
            this.$toast.error("Erro ao solicitar o endpoint da NFe");
            swal.close();
          });
      });
    }
  },
  computed: {
    config() {
      return this.layoutConfig();
    },
  },
  mounted() {

  },
};
